// extracted by mini-css-extract-plugin
export default {"twoColumn":"solar_twoColumn__G3HWj"};